import React, { useState, useCallback } from "react";
import * as styles from "../../styles/menu/floatButton.module.css";
import { useSpring, a, config } from "react-spring";

function FloatButton({
  Child,
  childProps,
  name,
  className,
  menuSelectCloseCard = false,
  number,
  buttonStyle,
}) {
  //To manage whether the floatcard is visible or not
  const [show, setShow] = useState(false);


  const FloatCardProps = useSpring({
    from: { transform: "translate3d(-50%,90%,0)", opacity: 0 },
    to: {
      transform: `translate3d(-50%,${show ? -50 : 90}%,0)`,
      opacity: show ? 1 : 0,
    },
    config: config.gentle,
  });

  
  const hideCard = useCallback(() => setShow(false), [setShow]);

  return (
    <React.Fragment>
      <div
        style={{ ...buttonStyle }}
        onClick={() => {
          //Show the menu
          setShow((state) => !state);
        }}
        className={`${styles.FloatButton} ${className}`}
      >
        {name}
        {number ? <div className={styles.numberindicator}>{number}</div> : null}
      </div>
      {show && (
        <div
          onClick={() => {
            setShow(false);
          }}
          // style={{background:'red'}}
          className="outsideClickDiv"
        />
      )}
      <a.div style={FloatCardProps} className={styles.FloatCard}>
        <div className={styles.FloatCardInnerContainer}>
          {
            <Child
              {...childProps}
              className={styles.FloatCardInner}
              onNameClickFunc={menuSelectCloseCard && hideCard}
            />
          }
        </div>
      </a.div>
    </React.Fragment>
  );
}

export default FloatButton;
